import pdfMake from 'pdfmake/build/pdfmake.js'
// import pdfFonts from 'pdfmake/build/vfs_fonts'
import pdfFonts from '@/assets/fonts/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
    THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf'
    },
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    }
}
export default {
    data () {
        return {
            objImage: {},
            imageDefault: 'data:image/png;base64,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'
        }
    },
    methods: {
        async getPictuerFirebase (shopId) {
            const getFirebaseShopPicturePath = (shopId) => {
                return 'shops/' + shopId + '/logo.jpg'
            }
            const env = (mode) => {
                if (mode === 'production') {
                    return 'prod'
                } else {
                    return mode
                }
            }
            let url = ''
            try {
                let storageRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).storage().ref()
                let directoryRef = await storageRef.child(getFirebaseShopPicturePath(shopId))
                url = await directoryRef.getDownloadURL()
            } catch (error) {
                console.log(error)
            }
            let response = await new Promise(resolve => {
                if (url !== '') {
                    var xhr = new XMLHttpRequest()
                    xhr.responseType = 'blob'
                    xhr.onload = (event) => {
                        var blob = xhr.response
                        console.log('-------', blob)
                        resolve({ blob: blob, shopId: shopId })
                    }
                    xhr.open('GET', url)
                    xhr.send()
                } else {
                    resolve({ blob: null, shopId: shopId })
                }
            })

            let responseBase64 = await new Promise(resolve => {
                // console.log(response)
                if (response.blob) {
                    let reader = new FileReader()
                    reader.readAsDataURL(response.blob)
                    reader.onloadend = () => {
                        let base64data = reader.result
                        resolve({ imgBase64: base64data, shopId: shopId })
                    }
                } else {
                    resolve({ imgBase64: this.imageDefault, shopId: shopId })
                }
            })
            return responseBase64
        },
        async getImageOnlineOperation ({ userId }) {
            let imageList = {
                bank_book_account: [],
                identify_card: [],
                vat_company: []
            }
            let imageUrl = {
                bank_book_account: '',
                identify_card: '',
                vat_company: ''
            }
            let imageBase64 = {
                bank_book_account: '',
                identify_card: '',
                vat_company: ''
            }
            let imageBase64Size = {
                bank_book_account: '',
                identify_card: '',
                vat_company: ''
            }
            const env = (mode) => {
                if (mode === 'production') {
                    return 'prod'
                } else {
                    return mode
                }
            }
            let storageRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).storage().ref()
            let directoryRef = await storageRef.child(`regular_customer_register/${userId}`)
            let listFolder = await directoryRef.listAll()
            for (const folderName of listFolder.prefixes) {
                let listItems = await folderName.listAll()
                for (const item of listItems.items) {
                    let itemRef = await storageRef.child(item.fullPath)
                    let metaitem = await itemRef.getMetadata()
                    imageList[folderName.name].push({
                        name: item.name,
                        metaItem: metaitem
                    })
                }
            }
            for (let [key, value] of Object.entries(imageList)) {
                console.log(value)
                imageList[key].sort(function (a, b) {
                    var c = new Date(a.metaItem.timeCreated)
                    var d = new Date(b.metaItem.timeCreated)
                    return d - c
                })
                imageList[key] = imageList[key][0]
            }
            for (let [key, value] of Object.entries(imageList)) {
                if (value) {
                    let directoryRef = await storageRef.child(value.metaItem.fullPath)
                    let userProfileUrl = await directoryRef.getDownloadURL()
                    imageUrl[key] = userProfileUrl
                } else {
                    imageUrl[key] = 'http://www.mayline.com/products/images/product/noimage.jpg'
                }
            }
            let imageBlob = {
                bank_book_account: null,
                identify_card: null,
                vat_company: null
            }
            for (let [key, value] of Object.entries(imageUrl)) {
                let response = await new Promise(resolve => {
                    if (value !== '') {
                        if (value === 'http://www.mayline.com/products/images/product/noimage.jpg') {
                            resolve({ blob: null })
                        } else {
                            var xhr = new XMLHttpRequest()
                            xhr.responseType = 'blob'
                            xhr.onload = (event) => {
                                var blob = xhr.response
                                // console.log('-------', blob)
                                resolve({ blob: blob })
                            }
                            xhr.open('GET', value)
                            xhr.send()
                        }
                    } else {
                        resolve({ blob: null })
                    }
                })
                imageBlob[key] = response
            }
            for (let [key, value] of Object.entries(imageBlob)) {
                let responseBase64 = await new Promise(resolve => {
                    if (value.blob) {
                        let reader = new FileReader()
                        reader.readAsDataURL(value.blob)
                        reader.onloadend = () => {
                            let base64data = reader.result
                            resolve({ imgBase64: base64data })
                        }
                    } else {
                        resolve({ imgBase64: null })
                    }
                })
                imageBase64[key] = responseBase64
            }
            for (let [key, value] of Object.entries(imageBase64)) {
                // console.log(key, value)
                let responeImageSize = await new Promise(resolve => {
                    // console.log('------>', key, value)
                    if (value.imgBase64) {
                        let im = new Image()
                        im.src = value.imgBase64
                        im.onload = () => {
                            let width = im.width
                            let height = im.height
                            let rotateImage = false
                            if (width > height) {
                                rotateImage = true
                            }
                            console.log('rotate', rotateImage)
                            resolve({ imgBase64: value.imgBase64, width: width, height: height, rotate: rotateImage })
                        }
                    } else {
                        resolve({ imgBase64: null, width: null, height: null })
                    }
                })
                imageBase64Size[key] = responeImageSize
            }
            return imageBase64Size
        },
        pdfUserInfo (userInfo, courierUser, shopList) {
            console.log('-----shopList', shopList[0], userInfo)
            const address = (saleCode) => {
                let address = ''
                address = `${userInfo.address ? userInfo.address : ''} ${userInfo.province ? userInfo.province : ''} ${userInfo.district ? userInfo.district : ''} ${userInfo.subDistrict ? userInfo.subDistrict : ''} ${userInfo.zipcode ? userInfo.zipcode : ''}`
                return address
            }
            let userInfoHeader = [
                { text: userInfo.userCode, fontSize: 18, bold: true },
                { text: `อีเมล์ลูกค้า : ${userInfo.email}`, fontSize: 16 },
                { text: `ชื่อ : ${userInfo.firstName} นามสกุล : ${userInfo.lastName}`, fontSize: 16 },
                { text: `ที่อยู่ : ${address(userInfo.saleCode)} `, fontSize: 16 },
                { text: `เบอร์โทรติดต่อเข้ารับสินค้า : ${userInfo.phoneNumber}`, fontSize: 16 },
                { text: `Sale Code : ${userInfo.saleCode}`, fontSize: 16 },
                { text: `Quotation Date : ${userInfo.quotationDate}`, fontSize: 16 }
            ]
            let tableCourier = [[
                { text: 'ลำดับ', style: 'tableHeader', alignment: 'center' },
                { text: 'ขนส่ง', style: 'tableHeader', alignment: 'center' },
                { text: 'Shipper Code', style: 'tableHeader', alignment: 'center' },
                { text: 'ผู้ใช้งาน', style: 'tableHeader', alignment: 'center' },
                { text: 'รหัสผ่าน', style: 'tableHeader', alignment: 'center' },
                { text: 'วัน', style: 'tableHeader', alignment: 'center' }
            ]]
            courierUser.forEach((e, index) => {
                let courier = [
                    { text: index + 1, alignment: 'center' },
                    { text: e.name, alignment: 'left' },
                    { text: e.apiData.status ? e.apiData.shipperCode : '-', alignment: 'left' },
                    { text: e.apiData.status ? e.apiData.username : '-', alignment: 'left' },
                    { text: e.apiData.status ? e.apiData.password : '-', alignment: 'left' },
                    { text: e.day, alignment: 'center' }
                ]
                tableCourier.push(courier)
            })
            let tableCourierBody = {
                style: 'tableCourier',
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', 'auto', 'auto', '*'],
                    body: tableCourier
                }
                // pageBreak: 'after'
            }

            // console.log(detail)
            return [userInfoHeader, tableCourierBody]
        },
        pdfShopList (shopList, objImage, userInfo, courierUser) {
            console.log(objImage)
            let shop = []
            if (shopList.length > 0) {
                for (let item of shopList) {
                    const getAddressShop = (e) => {
                        let address = `${e.address ? e.address : ''} ${e.province ? e.province : ''} ${e.district ? e.district : ''} ${e.subDistrict ? e.subDistrict : ''} ${e.zipcode ? e.zipcode : ''}`
                        return address
                    }
                    const getAddressShopPicklUp = (e) => {
                        let address = `${e.pickedUpAddress ? e.pickedUpAddress : ''} ${e.pickedUpProvince ? e.pickedUpProvince : ''} ${e.pickedUpDistrict ? e.pickedUpDistrict : ''} ${e.pickedUpSubDistrict ? e.pickedUpSubDistrict : ''} ${e.pickedUpZipcode ? e.pickedUpZipcode : ''}`
                        return address
                    }
                    let shopProfile = [

                        { text: `Shop Id : ${item.shopId}`, fontSize: 18, bold: true, pageBreak: 'before' },
                        { text: `ชื่อร้าน : ${item.name}`, fontSize: 16 },
                        { text: `Shop Code  : ${item.shopCode}`, fontSize: 16 },
                        { text: `ประเภทร้านค้า : ${this.getShopGoodsType(item.goodsType)}`, fontSize: 16 },
                        { text: `เบอร์โทรร้าน : ${item.phoneNumber}`, fontSize: 16 },
                        { text: `LINE : ${item.line}`, fontSize: 16 },
                        { text: `FACEBOOK : ${item.facebook}`, fontSize: 16 },
                        { text: `INSTAGRAM : ${item.instagram}`, fontSize: 16 },
                        { text: `ที่อยู่ใบปะหน้า : ${getAddressShop(item)}`, fontSize: 16 },
                        { text: `ที่อยู่เข้ารับสินค้า : ${getAddressShopPicklUp(item)}`, fontSize: 16 },
                        { text: `ประเภทบัญชี : ${this.getBankAccountType(item.bankAccountType)}`, fontSize: 16 },
                        { text: `ชื่อนิติบุคคล : ${item.legalName}`, fontSize: 16 },
                        { text: `ชื่อบัญชี : ${item.bankAccountName}`, fontSize: 16 },
                        { text: `เลขประจําตัวผู้เสียภาษี : ${item.taxId}`, fontSize: 16 },
                        { text: `อีเมล์สําหรับบัญชี : ${item.bankAccountEmail}`, fontSize: 16 },
                        { text: `ที่อยู่ตามใบกำกับภาษี : ${item.bankAccountAddress} ${item.bankAccountProvince} ${item.bankAccountDistrict} ${item.bankAccountSubDistrict} ${item.bankAccountZipcode}`, fontSize: 16 },
                        { text: `บัญชีธนาคาร : ${this.getBank(item.bankName)}`, fontSize: 16 },
                        { text: `หมายเลขบัญชีธนาคาร : ${item.bankAccountNumber}`, fontSize: 16 },
                        { text: `COD :`, fontSize: 16 },
                        {
                            image: objImage[item.shopId],
                            width: 150,
                            height: 150,
                            absolutePosition: { x: 400, y: 50 }
                        }
                    // margin: [ 20, 0, 0, 0 ]
                    ]

                    shop.push(shopProfile)
                    for (let [key, value] of Object.entries(item.financeConfig)) {
                        const codType = (cod) => {
                            if (cod.cod.serviceCharge.type === 0) {
                                return `${cod.cod.serviceCharge.percent.toFixed(2)} %`
                            } else {
                                return `${cod.cod.serviceCharge.value.toFixed(2)} บาท`
                            }
                        }
                        let text = [
                            { text: `${key} : ค่าบริการขั้นต่ำ ${value.cod.minimumCod.value} บาท ${codType(value)}`, margin: [ 35, 0, 0, 0 ], fontSize: 16 }
                        ]
                        shop.push(text)
                    }
                    let detail = []
                    if (userInfo.saleCode === '') {
                        let resultDay = []
                        let resultMap = []
                        if (shopList[0].pickedUpDay) {
                            shopList[0].pickedUpDay.forEach(e => {
                                resultDay.push(this.transportDays.find(s => s.id === e))
                            })
                            resultMap = resultDay.map(e => e.label)
                        }

                        detail = [
                            { text: ` `, fontSize: 18 },
                            { text: `ข้อมูลเข้ารับสินค้า`, fontSize: 18, bold: true },
                            { text: `ขนส่งที่ลูกค้าเลือก : ${courierUser[0].name}`, fontSize: 16 },
                            { text: `วันที่เข้ารับสินค้า : ${resultMap.join()}`, fontSize: 16 },
                            { text: `วันที่เริ่มส่งสินค้า : ${shopList[0].startPickupAt}`, fontSize: 16 }
                        ]
                    }
                    shop.push(detail)
                    let rateData = null
                    let textProfile = ''
                    if (userInfo.deliveryCostType === 1) {
                        rateData = item.weightRate
                        textProfile = 'Weight Rate card'
                    } else if (userInfo.deliveryCostType === 2) {
                        rateData = item.dimensionRate
                        const saveData = item.weightRate
                        delete saveData.scg
                        rateData = { ...rateData, ...saveData }
                        textProfile = 'Dimension Rate card'
                    }
                    if (rateData) {
                        for (let [key, value] of Object.entries(rateData)) {
                            if (userInfo.deliveryCostType === 2) {
                                textProfile = key !== 'scg' ? 'Weight Rate card' : 'Dimension Rate card'
                            }
                            let shopProfile = [
                                { text: `${key} ${textProfile}`, fontSize: 18, bold: true, pageBreak: 'before' }
                            ]
                            let tableWeightRate = [[
                                { text: 'ลำดับ', style: 'tableHeader', alignment: 'center' },
                                { text: 'Min', style: 'tableHeader', alignment: 'center' },
                                { text: 'Max', style: 'tableHeader', alignment: 'center' },
                                { text: 'Rate-BKK', style: 'tableHeader', alignment: 'center' },
                                { text: 'Rate-UPC', style: 'tableHeader', alignment: 'center' }
                            ]]
                            value.forEach((e, index) => {
                                let courier = [
                                    { text: index + 1, alignment: 'center' },
                                    { text: e.min.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), alignment: 'right' },
                                    { text: e.max.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), alignment: 'right' },
                                    { text: e.rateBkk.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), alignment: 'right' },
                                    { text: e.rateUpc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), alignment: 'right' }
                                ]
                                tableWeightRate.push(courier)
                            })
                            let tableCourierBody = {
                                style: 'tableCourier',
                                table: {
                                    headerRows: 1,
                                    widths: ['auto', '*', '*', '*', '*'],
                                    body: tableWeightRate
                                },
                                layout: {
                                    fillColor: function (rowIndex, node, columnIndex) {
                                        return (rowIndex % 2 === 0) ? '#CCCCCC' : null
                                    }
                                }
                            }
                            shop.push(shopProfile)
                            shop.push(tableCourierBody)
                        }
                    }
                }
                return shop
            } else {
                return shop
            }
        },
        pdfShopOnline (image) {
            let data = []
            for (let [key, value] of Object.entries(image)) {
                console.log(key, value)
                if (value.imgBase64) {
                    let shopProfile = []
                    if (value.rotate) {
                        shopProfile = [
                            // { text: `Shop Id :ssss`, fontSize: 18, bold: true, pageBreak: 'before' },
                            {
                                image: value.imgBase64,
                                // width: 520.00,
                                // height: 770.00,
                                // fit: [100, 100],
                                // fit: [520, 770],
                                fit: [770, 520],
                                pageOrientation: 'landscape',
                                pageBreak: 'before'
                            }
                        ]
                    } else {
                        shopProfile = [
                            // { text: `Shop Id :ssss`, fontSize: 18, bold: true, pageBreak: 'before' },
                            {
                                image: value.imgBase64,
                                fit: [500, 790],
                                pageBreak: 'before'
                            }
                        ]
                    }

                    data.push(shopProfile)
                }
            }
            return data
        },
        pdfOnlineDetail (userInfo, courierUser, shopList) {
            let detail = []
            if (userInfo.saleCode === '') {
                let resultDay = []
                shopList[0].pickedUpDay.forEach(e => {
                    resultDay.push(this.transportDays.find(s => s.id === e))
                })
                let resultMap = resultDay.map(e => e.label)
                detail = [
                    { text: `ข้อมูลเข้ารับสินค้า`, fontSize: 18, bold: true, pageBreak: 'before' },
                    { text: `ขนส่งที่ลูกค้าเลือก : ${courierUser[0].name}`, fontSize: 16 },
                    { text: `วันที่เข้ารับสินค้า : ${resultMap.join()}`, fontSize: 16 },
                    { text: `วันที่เริ่มส่งสินค้า : ${shopList[0].startPickupAt}`, fontSize: 16 }
                ]
            }
            console.log(detail)
            return detail
        },
        async pdfgen (userInfo, courierUser, shopList) {
            let promiseImg = []
            this.objImage = {}
            for (let item of shopList) {
                promiseImg.push(
                    await this.getPictuerFirebase(item.shopId)
                )
            }
            promiseImg.forEach(e => {
                this.objImage[e.shopId] = e.imgBase64
            })
            let userInfomation = await this.pdfUserInfo(userInfo, courierUser, shopList)
            let shop = await this.pdfShopList(shopList, this.objImage, userInfo, courierUser)
            // get image firebase
            let resultimageOnline = await this.getImageOnlineOperation(userInfo)
            let pdfImageOnline = await this.pdfShopOnline(resultimageOnline)
            // let pdfOnlineDetail = await this.pdfOnlineDetail(userInfo, courierUser, shopList)
            // console.log('->->->->', pdfImageOnline)
            let docDefinition = {
                content: [userInfomation, shop, pdfImageOnline],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableCourier: {
                        margin: [0, 5, 0, 15]
                    }
                },
                defaultStyle: {
                    font: 'THSarabunNew',
                    pageSize: 'A4'
                } }
            pdfMake.createPdf(docDefinition).download(`${userInfo.userCode} ${userInfo.firstName} ${userInfo.lastName}`)
        }
    }
}
